module.exports = __webpack_public_path__ + "img/1080_08.8fc42382.jpg";